
import { defineComponent, computed, onMounted, onUnmounted, ref, SetupContext } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "MypageFoodListItem",
  props: {
    /** お気に入り食材ID */
    foodId: {
       type: Number,
       required: true
    },
    /** 食材画像 */
    foodImage: {
      type: String,
      default: () => null
    },
    /** 食材名 */
    foodName: {
      type: String,
      default: () => null
    },
    /** お気に入り登録中 */
    isFavorite: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context: SetupContext) {

    // 画像読み込みエラー発生
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("MypageFoodListItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("MypageFoodListItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png"); 
      }
    };

    // 項目クリック
    const clickItem = () => {
      NativeClient.sendDebugLog("MypageFoodListItem clickItem foodId = " + props.foodId);
      context.emit("click-item", props.foodId, !props.isFavorite);
    };

    // お気に入り
    const clickFavorite = (e: Event) => {
      e.stopPropagation();
      NativeClient.sendDebugLog("MypageFoodListItem clickFavorite foodId = " + props.foodId + ", isFavorite = " + props.isFavorite);
      context.emit("click-favorite", props.foodId, !props.isFavorite);
    };

    // 買い物リスト
    const clickShoppingList = (e: Event) => {
      e.stopPropagation();
      NativeClient.sendDebugLog("MypageFoodListItem clickShoppingList foodId = " + props.foodId);
      context.emit("click-shopinglist", props.foodId);
    };

    return {
      onImageError,
      clickItem,
      clickFavorite,
      clickShoppingList
    };
  }
});
